import React from 'react';

import { useSelector } from 'react-redux';

import { BuildStatusProvider } from 'src/components/build-status-card/services/build-status-service/build-status-service';
import { getBranchViewSourceBranchName } from 'src/redux/repository/branch/branch-redux';
import { useBranchUrls } from 'src/sections/repository/sections/branch/urls';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import urls from 'src/urls/source';

export const BranchBuildStatusProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const branchName = useSelector(getBranchViewSourceBranchName);
  const repositoryFullName = useSelector(getCurrentRepositoryFullSlug);
  const { branchBuildStatuses } = useBranchUrls();

  let buildStatusURL;
  let repositoryMetadataURL;
  let repositoryFullSlug;
  if (repositoryFullName && branchName) {
    repositoryFullSlug = repositoryFullName;
    buildStatusURL = branchBuildStatuses(branchName);
    repositoryMetadataURL =
      urls.api.internal.repositoryMetadataURL(repositoryFullName);
  }

  return (
    <BuildStatusProvider
      repositoryFullSlug={repositoryFullSlug}
      buildStatusURL={buildStatusURL}
      repositoryMetadataURL={repositoryMetadataURL}
    >
      {children}
    </BuildStatusProvider>
  );
};
